import { instance } from "../store";

/* actionTypes */
import {
  FETCH_USER_DATA_BEGIN,
  FETCH_USER_DATA_SUCCESS,
  FETCH_USER_DATA_FAILURE,
  SET_AUTH_STATUS,
  SET_USER_LOGOUT,
} from "../actionTypes/userDataActionTypes";

/* actionCreatos */
export const setAuthStatus = (data) => ({
  type: SET_AUTH_STATUS,
  payload: data,
});

export const setUserLoggedOut = () => ({
  type: SET_USER_LOGOUT,
});

export const fetchUserDataBegin = () => ({
  type: FETCH_USER_DATA_BEGIN,
});

export const fetchUserDataSuccess = (data) => ({
  type: FETCH_USER_DATA_SUCCESS,
  data,
});

export const fetchUserDataFailure = (error) => ({
  type: FETCH_USER_DATA_FAILURE,
  error,
});

/* Thunk */
export function fetchUserData(params) {
  return async (dispatch) => {
    try {
      const response = await instance.post("", params);
      if (response.data.state === "error") {
        return dispatch(
          fetchUserDataFailure(
            response.data.result !== ""
              ? response.data.result
              : "Something went wrong. Reload the page or visit later"
          )
        );
      }
      return dispatch(fetchUserDataSuccess(response.data.result));
    } catch (error) {
      return dispatch(
        fetchUserDataFailure(
          "Something went wrong. Reload the page or visit later"
        )
      );
    }
  };
}
